// the available categories
export const categories = [
    "all",
    "materials",
    "instruments",
    "units",
];